import EditablePropsType from '../../../types/composer';
import { TEXT_COLOR_OPTIONS } from '../../../constants/composer';
import { fontSizeSchema } from './font';

export const subheadingSchema = {
  type: EditablePropsType.Text,
  label: 'Subheading',
  name: 'subheading',
};

export const subheadingAlignmentSchema = {
  type: EditablePropsType.Select,
  label: 'Subheading Alignment',
  name: 'subheadingAlignment',
  selectOptions: {
    options: [
      { value: 'center', label: 'Center' },
      { value: 'left', label: 'Left' },
      { value: 'right', label: 'Right' },
    ],
  },
};

export const subheadingTextColorSchema = {
  type: EditablePropsType.Select,
  label: 'Subheading Text Color',
  name: 'subheadingTextColor',
  selectOptions: {
    options: TEXT_COLOR_OPTIONS,
  },
};

export const subheadingFontSizeSchema = {
  ...fontSizeSchema,
  name: 'subheadingFontSize',
  label: 'Subheading Font Size',
};

export default subheadingSchema;
